import { Box, Button, Card, Flex } from "@engaging-tech/components"
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"

import Title from "./title"

const SurveyCard = ({
  children,
  title,
  richTitle,
  onNext,
  onPrevious,
  isLastQuestion,
  isValid = true,
  answer,
  noActions,
  isLastSection,
  type
}) => {
  const handleKeyPress = event => {
    const handleNextKeyCodes = [39, 13]
    const handlePreviousKeyCodes = [37]
    const keyCode = event.which

    const target = event.target
    if (target && (target.tagName === "INPUT" || target.tagName === "TEXTAREA")) {
      return
    }

    const isNavigationKey = handleNextKeyCodes.includes(keyCode) || handlePreviousKeyCodes.includes(keyCode)
    if (!isNavigationKey) return

    event.preventDefault()

    if (!(isLastQuestion && isLastSection) && handleNextKeyCodes.includes(keyCode) && isValid) {
      onNext()
    } else if (handlePreviousKeyCodes.includes(keyCode)) {
      onPrevious()
    }
  }

  useEffect(() => {
    if (type !== "short-text") {
      window.addEventListener("keydown", handleKeyPress)

      return () => window.removeEventListener("keydown", handleKeyPress)
    }

    return undefined
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isValid, answer])

  const { t } = useTranslation(["organisation_survey"])

  const rightButtonText =
    isLastQuestion && isLastSection ? t("code_check.submit", "") : t("questions.next", "")

  const leftButtonText = t("questions.previous", "")

  return (
    <Card bg="light.0">
      {(title || richTitle) && <Title richTitle={richTitle}>{title}</Title>}
      <Box p={3} data-testid="survey-answer-area">{children}</Box>
      {!noActions && (
        <Flex flexDirection="row-reverse" justifyContent="space-between" p={3} pt={0}>
          <Box width="auto">
            {onNext && (
              <Button data-testid="survey-next-btn" variant="primary.0" onClick={onNext} disabled={!isValid}>
                {rightButtonText}
              </Button>
            )}
          </Box>
          <Box width="auto">
            {onPrevious && (
              <Button data-testid="survey-prev-btn" variant="text.dark.2" elevation={0} onClick={onPrevious}>
                {leftButtonText}
              </Button>
            )}
          </Box>
        </Flex>
      )}
    </Card>
  )
}

export default SurveyCard
